export default {
  PublicPath : (process.env.BASE_URL as string)
}